import NewCourseCreator from "src/components/NewComponents/Creator/NewCourseCreator";

import { CreatorContainer } from "./CreatorContainer";

function GenerateCourse() {
	return (
		<CreatorContainer>
			<NewCourseCreator />
		</CreatorContainer>
	);
}

export default GenerateCourse;
